export enum DownloadResolution {
  Low = 'direct_download_lowres',
  High = 'direct_download_highres',
}
